import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export enum NavBadgeKeys {
  Alerts = 'alerts',
}

@Injectable({
  providedIn: 'root',
})
export class NavBadgeService {
  private readonly badgeCounts = new Map<NavBadgeKeys, BehaviorSubject<number>>();

  setCount(key: NavBadgeKeys, count: number): void {
    this.getSubject(key).next(count);
  }

  count$(key: NavBadgeKeys): Observable<number> {
    return this.getSubject(key).asObservable();
  }

  private getSubject(key: NavBadgeKeys): BehaviorSubject<number> {
    if (!this.badgeCounts.has(key)) {
      this.badgeCounts.set(key, new BehaviorSubject<number>(0));
    }

    return this.badgeCounts.get(key)!;
  }
}
